import { Cart, CartDetails } from 'src/app/utility/model/cart';

export interface CartState {
  cartCount: number;
  cartDetails: CartDetails;
  cartItems: Cart[];
  cartStatus: string;
  spinner: boolean;
  error?: any;
  movedToEmptyCart: boolean;
  refreshCart: string;
}

export const initialState: CartState = {
  cartCount: 0,
  cartDetails: {},
  cartItems: [],
  cartStatus: '',
  spinner: false,
  movedToEmptyCart: true,
  refreshCart: '',
};
